export const CHART_OPTIONS = {
    chart: {
        id: 'affinity-hub-distribution-by-yoe',
        toolbar: {
            show: false,
        },
    },
    noData: {
        text: 'No data to display',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: '#000000',
          fontSize: '14px',
        }
    },
    colors: ['#AD509E'],
    legend: { show: false },
    xaxis: {
        title: {
            text: 'Years of Experience',
            style: {
                color: '#667085',
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 500,
                cssClass: 'apexcharts-xaxis-title',
            },
        },
        labels: {
            style: {
                colors: Array.from({ length: 20 })?.map(()=> '#667085'),
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 400,
                cssClass: 'apexcharts-xaxis-label',
            },
        },
        crosshairs: {
            show: false,
        },
    },
    yaxis: {
        title: {
            text: "Total HCPs",
            style: {
                color: '#667085',
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 500,
                cssClass: 'apexcharts-yaxis-title',
            },
        },
        labels: {
            style: {
                colors: ['#667085'],
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 400,
                cssClass: 'apexcharts-yaxis-label',
            },
        },
    },
    tooltip: {
        custom: function({series, seriesIndex, dataPointIndex, w}) {
            let value = series[seriesIndex][dataPointIndex];

            return `<div class="distribution-by-yop-custom-tool-tip arrow_box"> 
                    <p class="tool-tip-series-name">${value}</p>                
                </div>`
        }        
    },
    grid: {
        show: false,
    },
    plotOptions: {
        bar: {
            columnWidth: '80%',
            borderRadius: 2,
        },
    },
    stroke: {
        show: true,
        width: 2,
        colors: ['transparent'],
    },
    dataLabels: {
        enabled: false,
    },
};
export const CHART_SERIES = [
    {
        name: '',
        data: [
            { x: 'less than 5 years', y: 300 },
            { x: '5 - 10 years', y: 800 },
            { x: '10 - 15 years', y: 812 },
            { x: '15 - 20 years', y: 600 },
            { x: '20+ years', y: 250 },
        ],
    },
];
